import { useSearchParams } from "react-router-dom";

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryParams = Object.fromEntries([...searchParams.entries()]);

  const updateQueryParams = (updates) => {
    const newParams = new URLSearchParams(searchParams.toString());

    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === undefined || value === "") {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }
    });

    setSearchParams(newParams);
  };

  const resetQueryParams = () => {
    setSearchParams({});
  };

  const removeQueryParams = (keys) => {
    const newParams = new URLSearchParams(searchParams.toString());
    (Array.isArray(keys) ? keys : [keys]).forEach((key) => {
      newParams.delete(key);
    });
    setSearchParams(newParams);
  };

  return {
    queryParams,
    updateQueryParams,
    resetQueryParams,
    removeQueryParams,
  };
};

export default useQueryParams;
